import { ABPaymentForm } from '../lib/ab/payment';
import { makePlanCard } from '../lib/ab/plan-card';
import { aTrackPage } from '../lib/mdl/a-track';
import { cPlanDiscountedPrice } from '../lib/mdl/c-plan';
import { CLoginUser, CPaidPlanId } from '../lib/mdl/c-user';
import { meAction, meGetInfo, MEInfoSubscribe, meUseCode, MeUseCodeResponse } from '../lib/me/home';
import { the_user, the_user_is_new } from '../lib/me/login';
import { UIButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UITextInput } from '../lib/ui/component/input';
import { uiToast } from '../lib/ui/component/toast';
import { UIExclusiveToggles, UIToggle } from '../lib/ui/component/toggle';
import { $el } from '../lib/ui/elements';
import { uiLock } from '../lib/ui/functions';
import { UIScreen } from '../lib/ui/screen';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $analytics } from '../lib/y/analytics';
import { $on } from '../lib/y/events';
import { $form } from '../lib/y/form';
import { $format } from '../lib/y/format';
import { $i18n } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { HomeMenu } from './menu';

class PromoDialog extends UIDialog<MeUseCodeResponse> {
    constructor() {
        super({ close: true, classes: 'm-550' })

        const code = new UITextInput({ required: true, placeholder: $i18n.tl.ph_voucher_code, autofocus: true });

        this.content.ui_add([
            $el.DIV('w-block l-form m-center', [
                $el.H2('title', $i18n.tl.t_promo_code),
                code,
                $el.DIV('l-button-row', [
                    new UIButton({
                        title: $i18n.tl.b_apply_code, classes: 'ui-tint-reverse', on_click: () => {
                            if(!$form.validate(code)) return;

                            meUseCode('subscribe', code.value).then(response => {
                                this.dismiss(response);
                            }, uiToast);
                        }
                    })
                ])
            ])
        ]);
    }
}

class SubscriptionSection extends UIView {
    constructor(info: MEInfoSubscribe, plan?: CPaidPlanId) {
        const plan_toggle = new UIExclusiveToggles(info.plans, plan => {
            return new UIToggle(makePlanCard('k-choose m-pink', 'm-hollow', plan, info.promo), { key: plan.id });
        }, { required: true, classes: 'r-kind' });

        const start = new UIButton({
            title: $i18n.tl.h_choose_membership, classes: 'ui-tint-reverse', on_click: () => {
                this.ui_replace(new PaymentSection(plan_toggle.value!, !info.dont_activate));
            }
        });

        start.disabled = true;

        $on(plan_toggle, 'value', plan => {
            if(plan) {
                start.disabled = false;
                start.title = $i18n.tl.b_start_for + ' ' + $format.currency(cPlanDiscountedPrice(info.plans.find(p => p.id == plan)!, info.promo));
            }
        });

        if(plan)
            plan_toggle.value = plan;

        super('section', 'ui-section', [
            $el.DIV('w-block', [
                $el.P('title', $i18n.tl.h_choose_membership),
                $el.P('info', $i18n.tl.t_choose_membership)
            ]),
            $el.DIV('tl-options-block', plan_toggle),
            $el.DIV('s-section'),

            info.show_promo_field && [
                $el.DIV('l-button-row', new UIButton({
                    title: $i18n.tl.b_have_code, kind: 'k-text', on_click: () => {
                        new PromoDialog().present().then(response => {
                            if(response.kind == 'giftcard') {
                                $location.navigate([]);
                                return;
                            }
                            if(response.promo) {
                                info.promo = response.promo;
                                info.show_promo_field = false;
                                this.ui_replace(new SubscriptionSection(info, plan_toggle.value));
                            }
                        })
                    }
                })),
                $el.DIV('s-section')
            ],
            $el.DIV('l-button-row', start)
        ]);
    }
}

class PaymentSection extends UIView {
    constructor(plan: CPaidPlanId, activate: boolean) {
        super('section', 'ui-section');

        uiLock(meAction('subscribe', { plan: plan }).then(r => {
            if(r === true) {
                $location.navigate([], { onboarding: true });
            } else {
                this.ui_add([
                    $el.DIV('w-block l-form m-center', [
                        $el.P('title', $i18n.tl.h_payment),
                        new ABPaymentForm(r, {
                            finish: (model: CLoginUser) => {
                                Object.assign(the_user!, model);
                                $location.navigate([], { onboarding: true });
                            }
                        }),
                        (!activate && r.amount.value == 0) && $el.P('small', $i18n.tl.t_signup_dont_activate_text)
                    ])
                ]);
            }
        }));
    }
}

export class HomeSubscribeScreen extends UIScreen {
    constructor(private _plan?: CPaidPlanId) {
        super({ menu: new HomeMenu({ is_signup: true, no_logout: the_user_is_new }) });
    }

    protected override fillContent(content: UIViewSpec): void {
        $analytics.track('Onboarding Choose Subscription');
        meGetInfo('subscribe').then(info => {
            content.ui_add(new SubscriptionSection(info, this._plan));
        })

        aTrackPage('subscribe');
    }
}
